import { render } from "./page-back.vue?vue&type=template&id=50ba3aa4&scoped=true&ts=true"
import script from "./page-back.vue?vue&type=script&lang=ts"
export * from "./page-back.vue?vue&type=script&lang=ts"

import "./page-back.vue?vue&type=style&index=0&id=50ba3aa4&lang=less&scoped=true"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ba3aa4"]])

export default __exports__